import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { key: 0 }

import LoginPage from '@/pages/LoginPage.vue'
import store from '@/store'
import { computed } from 'vue'
import useFormRequest from '@/composables/useFormRequest'
import { loadUser } from '@/api/auth'
import HeaderBlock from '@/components/HeaderBlock.vue'
import { loadRegions } from './api/regions'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const user = computed(() => store.state.user)

const token = (new Map<string, string>(
  document.cookie.split(';').map(cookie => cookie.split('=').map(v => v.trim()) as [string, string])
)).get('cToken')

const request = useFormRequest()

if (token) {
  request.tryRequest(async () => {
    const response = await loadUser(token)
    store.login(response.data)

    const regionsResponse = await loadRegions()
    store.setRegions(regionsResponse.data)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(request).state.pending)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)), [
          [_directive_loading]
        ])
      : (user.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(HeaderBlock),
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component, route }) => [
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("main", {
                      class: "content",
                      key: route.path
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ]))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _cache[0] || (_cache[0] = _createElementVNode("footer", { class: "footer" }, null, -1))
          ], 64))
        : (_openBlock(), _createBlock(LoginPage, { key: 2 }))
  ]))
}
}

})